<template>
    <div class="commune-chart">
        <DashboadCard style="min-height: 200px; height: 100%;">
            <div class="commune-chart__header">
                <DashboardIcon icon="map" color="#556EE6" />
                <div class="commune-chart__header-texts">
                    <div class="commune-chart__title">Envíos por Comuna</div>
                    <div class="commune-chart__subtitle">Distribución geográfica de envíos en el período</div>
                </div>
            </div>
            <div v-if="chartData.length" class="commune-chart__body">
                <div class="commune-chart__canvas">
                    <PieChart :chartLabels="chartLabels" :chartData="chartData" style="width: 100%; height: 100%;" />
                </div>
                <div class="commune-chart__legend">
                    <div v-for="(item, i) in legendItems" :key="i" class="legend-item">
                        <span class="legend-item__dot" :style="{ backgroundColor: item.color }"></span>
                        <span class="legend-item__label">{{ item.label }}</span>
                        <span class="legend-item__value">{{ item.value }}</span>
                    </div>
                    <div class="legend-total">
                        <span class="legend-total__label">Total</span>
                        <span class="legend-total__value">{{ totalDeliveries }}</span>
                    </div>
                </div>
            </div>
            <div v-else class="commune-chart__empty">Sin datos para el período seleccionado</div>
        </DashboadCard>
    </div>
</template>

<script>
import DashboadCard from './DashboadCard.vue';
import DashboardIcon from './DashboardIcon.vue';
import PieChart from './PieChart.vue';
import { mapGetters } from 'vuex';
import { thousandSeparator } from '../../utils/helpers';

const COLORS = [
    '#34C38F', '#50A5F1', '#F1B44C', '#F46A6A', '#556EE6',
    '#74788D', '#343A40', '#51D28C', '#3B82F6', '#A855F7',
    '#EF4444', '#F59E0B', '#10B981', '#6366F1', '#EC4899'
];

export default {
    name: 'CommuneChartSection',
    components: {
        DashboadCard,
        DashboardIcon,
        PieChart
    },
    computed: {
        ...mapGetters(['deliveriesByCommune']),
        chartLabels() {
            const data = this.deliveriesByCommune || [];
            if (data.length <= 10) return data.map(d => d.commune);
            const top = data.slice(0, 10).map(d => d.commune);
            return [...top, 'Otras'];
        },
        chartData() {
            const data = this.deliveriesByCommune || [];
            if (data.length <= 10) return data.map(d => d.count);
            const top = data.slice(0, 10).map(d => d.count);
            const rest = data.slice(10).reduce((sum, d) => sum + d.count, 0);
            return [...top, rest];
        },
        legendItems() {
            return this.chartLabels.map((label, i) => ({
                label,
                value: thousandSeparator(this.chartData[i]),
                color: COLORS[i % COLORS.length]
            }));
        },
        totalDeliveries() {
            return thousandSeparator(this.chartData.reduce((sum, v) => sum + v, 0));
        }
    }
}
</script>

<style scoped>
.commune-chart__header {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
}

.commune-chart__header-texts {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
}

.commune-chart__title {
    font-size: 0.95rem;
    font-weight: 600;
}

.commune-chart__subtitle {
    font-size: 0.8rem;
    opacity: 0.6;
}

.commune-chart__body {
    display: flex;
    gap: 1.5rem;
    align-items: center;
    justify-content: center;
}

.commune-chart__canvas {
    width: 250px;
    height: 250px;
    flex-shrink: 0;
    position: relative;
}

.commune-chart__legend {
    width: 220px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.82rem;
}

.legend-item__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
}

.legend-item__label {
    flex: 1;
    color: #555;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.legend-item__value {
    font-weight: 700;
    color: #333;
    min-width: 30px;
    text-align: right;
}

.legend-total {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid #eee;
    font-size: 0.85rem;
}

.legend-total__label {
    flex: 1;
    font-weight: 600;
    color: #333;
    padding-left: 18px;
}

.legend-total__value {
    font-weight: 700;
    font-size: 0.95rem;
    color: #333;
    min-width: 30px;
    text-align: right;
}

.commune-chart__empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #999;
    font-size: 0.9rem;
}

@media (max-width: 768px) {
    .commune-chart__body {
        flex-direction: column;
    }

    .commune-chart__legend {
        width: 100%;
    }
}
</style>
